import {componentLoader, componentConfig} from "../../../../lib/component_initializer";
import {NavRoot} from "./nav_root"

export const navRootLoader = function (options = {}) {
    componentLoader(componentConfig(NavRoot, NavRoot.config.componentTypeKey, NavRoot.config.baseHtmlClass), options);
};

